<template>
<div class="chapter">
<div class="inner_page">
<a id="page_v">
<h1 class="tochead">Contents</h1>
</a><h2 class="toc_fm"><a id="page_v"></a><a href="#/xhtml/05_List_of_Plates">List of Plates</a></h2>
<h2 class="toc_fm"><a href="#/xhtml/06_Glossary">Glossary</a></h2>
<h2 class="toc_fm"><a href="#/xhtml/07_Introduction">Introduction</a></h2>
<h2 class="toc_chap"><a href="#/xhtml/08_Chapter_1"><span class="toc_hang">1.</span> The State of the Nation – Sparta in 478 <span class="smallcaps">BC</span></a></h2>
<h2 class="toc_chap"><a href="#/xhtml/09_Chapter_2"><span class="toc_hang">2.</span> The First Cracks</a></h2>
<h2 class="toc_chap"><span href="#/xhtml/10_Chapter_3" title="Link target outside of Sample"><span class="toc_hang">3.</span> The Misadventures of Pausanias</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/11_Chapter_4" title="Link target outside of Sample"><span class="toc_hang">4.</span> The Slide into War</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/12_Chapter_5" title="Link target outside of Sample"><span class="toc_hang">5.</span> The Archidamian War</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/13_Chapter_6" title="Link target outside of Sample"><span class="toc_hang">6.</span> Sphacteria and the Peace of Nicias</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/14_Chapter_7" title="Link target outside of Sample"><span class="toc_hang">7.</span> A Successful War and a Failed Peace</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/15_Chapter_8" title="Link target outside of Sample"><span class="toc_hang">8.</span> The Lame King</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/16_Chapter_9" title="Link target outside of Sample"><span class="toc_hang">9.</span> The Disaster at Leuctra</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/17_Chapter_10" title="Link target outside of Sample"><span class="toc_hang">10.</span> The Rise of Macedon</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/18_Chapter_11" title="Link target outside of Sample"><span class="toc_hang">11.</span> The Failed Reformers</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/19_Chapter_12" title="Link target outside of Sample"><span class="toc_hang">12.</span> Nabis and the End of Sparta</span></h2>
<h2 class="toc_bm"><span href="#/xhtml/20_Epilogue" title="Link target outside of Sample">Epilogue</span></h2>
<h2 class="toc_bm"><span href="#/xhtml/21_Bibliography" title="Link target outside of Sample">Bibliography</span></h2>
<a id="page_vi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?6edf37e8